<div class="row">
  <div class="question_progress">
    <div class="question-caption">{{t question_caption}}</div>
    <div class="current-question">{{indexToCount question_index}}</div>
    <div class="question-separator">{{t question_separator}}</div>
    <div class="total-questions">{{total_questions}}</div></div>
  </div>
</div>
